import * as React from 'react';
import { Route, RouteComponentProps, Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';

interface IBreadCrumbParams {
  auftragId?: string;
  vorgangId?: string;
}

type BreadCrumbProps = RouteComponentProps<IBreadCrumbParams>;

export default class BreadCrumbs extends React.Component<{}, {}> {
  render() {
    return (
      <ol className="breadcrumb maxwidth">
        <BreadCrumbItem label="Home" to="/" />
        <Route
          path="/login"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Login" to={props.match.url} />}
        />
        <Route
          path="/profile"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Benutzerprofil" to={props.match.url} />}
        />
        <Route
          path="/kontakt"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Kontakt" to={props.match.url} />}
        />
        <Route
          path="/portal"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Portal" to={props.match.url} />}
        />
        <Route
          path="/qm"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="QM-Dokumentation" to={props.match.url} />}
        />
        <Route
          path="/arbeitsmittel"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Arbeitsmittel" to={props.match.url} />}
        />
        <Route
          path="/auftraege"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Aufträge" to={props.match.url} />}
        />
        <Route
          path="/auftrag/:auftragId"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Auftrag" to={props.match.url} />}
        />
        <Route
          path="/auftrag/neu"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Neu" to={props.match.url} />}
        />
        <Route
          path="/auftrag/:auftragId/vorgang/:vorgangId"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Vorgang" to={props.match.url} />}
        />
        <Route
          path="/auftrag/:auftragId/objekte"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Objekt" to={props.match.url} />}
        />
        <Route
          path="/auftrag/:auftragId/objekte/anlegen"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Neu" to={props.match.url} />}
        />
        <Route
          path="/auftrag/:auftragId/vorgang/:vorgangId/arbeitsmittel"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Arbeitsmittel" to={props.match.url} />}
        />
       <Route
          path="/belege"
          render={(props: BreadCrumbProps) => <BreadCrumbItem label="Belege" to={props.match.url} />}
        />
      </ol>
    );
  }
}

interface IBreadCrumbItemProps extends IBreadCrumbParams {
  label: string;
  to: string;
}

class BreadCrumbItem extends React.Component<IBreadCrumbItemProps, {}> {

  render() {
    const { label, to } = this.props;
    return (
      <li className="breadcrumb-item">
        <Link to={to}>{label === 'Home' ? <Glyphicon glyph="home" /> : label}</Link>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/BreadCrumbs.tsx